import {Moarify} from '@programming/moarify';
import {ContactsDropdown} from './contacts_dropdown';
import {translations} from './translations.js.erb'

var modal;
var list;
var moarify;
var listingIds
var saveBtn;
var contactDropdown;
var contactId;
var newlyCreatedCollections = [];

function init(selector){
  modal = $(selector);
  list = modal.find('.addToCollectionModalList');
  saveBtn = modal.find('.addToCollectionModalSaveBtn');

  setupNewCollectionForm();

  modal.unbind("shown.bs.modal", handleShown).on("shown.bs.modal", handleShown);

  $(document).on('change', '.addToCollectionCheckbox', maybeEnableSaveBtn);

  modal.on('hidden.bs.modal', function(e) {
    if(typeof contactDropdown !== 'undefined'){
      contactDropdown.destroy();
      contactDropdown = undefined;
    }
    if(typeof moarify !== 'undefined'){
      moarify.destroy();
    }
    list.html('');
    newlyCreatedCollections = [];

    $('.newCollectionForm').hide();
    $('.newCollectionBtn').show();

  });

  saveBtn.click(addListingToCollections);
}

function maybeEnableSaveBtn() {
  var disabled = (modal.find('.addToCollectionCheckbox:checked').length < 1);
  modal.find('.addToCollectionModalSaveBtn').prop('disabled', disabled)
}

function handleShown(e) {
  listingIds = e.relatedTarget.dataset.listingIds;

  if(e.relatedTarget.dataset.contact === 'true') {
    $('.newCollectionWrapper').hide();
    $('.add-to-collection-contact-selector-form-group').show();
    contactDropdown = new ContactsDropdown('.contactDropdown');

    contactDropdown.unbind('change', handleContactSelect);
    contactDropdown.on('change', handleContactSelect);

  } else {
    contactId = undefined;
    $('.newCollectionWrapper').show();
    $('.add-to-collection-contact-selector-form-group').hide();
    loadCollections();
  }
}

function handleContactSelect() {
  $('.newCollectionWrapper').show();

  contactId =  $(this).val();
  list.html('');
  loadCollections();
}

function addListingToCollections(e) {
  e.preventDefault();

  var checkedInputs = list.find('input:checked');
  var collectionIds = checkedInputs.map(function() { return $(this).val(); });

  var queue = collectionIds.length;
  var errors = 0;

  showPageLoadingMsg();

  collectionIds.each(function() {
    var ajaxPromise = addListingToColleciton(this.toString());

    ajaxPromise.fail(function(jqXHR, textStatus, errorThrown) {
      errors += 1;
    });
    
    ajaxPromise.always(function() {
      queue -= 1;
      if(queue === 0){
        hidePageLoadingMsg();
        if(errors === 0){
          hidePageLoadingMsg();
          modal.modal('hide');
          toast.success(translations.listings.add_to_collection_modal.listing_added);
        } else {
          toast.error(translations.listings.add_to_collection_modal.cart_add_failure, false);
        }
      }
    });
  });
}

function addListingToColleciton(collectionId) {
  var data = {
    listing_ids: listingIds,
  }
  return $.ajax({
    method: 'POST',
    url: routes.collection_add_listings_path(contactId, collectionId),
    data: data
  });
}


function loadCollections() {

  if(typeof moarify !== 'undefined'){
    moarify.destroy();
  }

  moarify = new Moarify({
    appendTo: list,
    ajaxUrl: routes.collections_path(contactId),
    useSessionStorage: false,
    currentPage: 0,
    perPage: 10,
    dataType: 'json',
    processResponse: processCollectionJson,
    scrollElement: modal.find('.c-modal__content'),
    infiniteScroll: true
  });

  moarify.run();
}

function processCollectionJson(data) {

  var collectionHtmls = [];
  var portalCartsCount = 0;

  data.collections.forEach(function(collection) {
    // If a new collection has been created, we don't want it to appear in the list
    // later on when moarify loads a new page. We also don't want the built in portal 
    // carts to appear in the list.
    
    var keeper = true;

    if (newlyCreatedCollections.indexOf(collection.Id) >= 0 ) {
      keeper = false;
    } else if ( typeof collection.PortalCartType !== 'undefined' && collection.PortalCartType !== 'Custom') {
      keeper = false;
      portalCartsCount++;
    }

    if (keeper) {
      collectionHtmls.push( buildCollectionHtml(collection) );
    }
  });

  if(typeof data.pagination !== 'undefined'){
    moarify.setTotalItems(data.pagination.total_entries);
  }

  return collectionHtmls.join('');
}

function buildCollectionHtml(collection, checked){
  var checkedAttr = checked ? 'checked="checked"' : '';
  var out =   '<div class="c-list-entry"><div class="c-list-entry__title">'
      out +=    '<input ' + checkedAttr + ' class="addToCollectionCheckbox" id="collection_' + collection.Id + '" type="checkbox" value="' + collection.Id + '">';
      out +=    '<label class="add-to-collection-label" for="collection_' + collection.Id + '">' + collection.Name + '</label>';
      out +=  '</div></div>';

  return out;
}

function setupNewCollectionForm() {
  var form = $('.newCollectionForm');
  var input = $('.newCollectionForm input');
  var addBtn = $('.newCollectionForm button');

  form.hide();

  $('.newCollectionBtn').click(function(e) {
    e.preventDefault();
    $(this).hide();
    form.show();
    input.focus();
  });

  input.keyup(function(e) {
    var disabled = ($(this).val().length < 1);
    addBtn.prop('disabled', disabled)
  });

  addBtn.click(function(e) {
    e.preventDefault();
    createNewCollection(input.val());
  });

}

function createNewCollection(name) {
  $.ajax({
    url: routes.collections_path(contactId),
    method: 'POST',
    data: {collection: {Name: name}},
    success: function(newCollection) {
      newlyCreatedCollections.push(newCollection.Id);
      $('.newCollectionForm input').val('');
      $('.newCollectionForm button').prop('disabled', true)
      var html = buildCollectionHtml(newCollection, true);
      $(html).hide().prependTo(list).fadeIn();
      maybeEnableSaveBtn();
      $('.newCollectionForm').hide();
      $('.newCollectionBtn').show();
    },
    error: function() {
      toast.error(translations.listings.add_to_collection_modal.error_creating_collection, false);
    }
  });
}

export let addToCollectionModal = {
  init: init
};
